import * as notificationConstants from "./constants";
import * as notificationTypes from "./types";
import { truncateString } from "../../helpers/string";

function notify(notificationLevel, message, icon, button) {
    const truncatedMessage = truncateString(message, 512);
    return {
        type: notificationTypes.ADD_NOTIFICATION,
        level: notificationLevel,
        icon,
        message: truncatedMessage,
        button
    };
}

function clearNotification(notificationId) {
    return {
        type: notificationTypes.REMOVE_NOTIFICATION,
        notificationId
    };
}

export function removeNotification(notificationId) {
    return dispatch => dispatch(clearNotification(notificationId));
}

/**
 * Notification actions (all are the same except styling). Notifications will be added to any
 * <NotificationContainer/> in the dom
 *
 * @param message (required)
 *      The text you want to display to the user
 * @param icon (optional)
 *      An icon string (font-awesome icon without the "fa-" at the beginning). This displays to the left
 *      of your text
 * @param button (optional)
 *        An object with the following
 *          {
 *              text: The text to appear on the button,
 *              props: A valid props object to be passed to the button in components/button
 *          }
 * @returns {function(*): *}
 */

export function notifyError(message, icon, button) {
    return dispatch =>
        dispatch(
            notify(
                notificationConstants.NOTIFICATION_LEVEL_ERROR,
                message,
                icon,
                button
            )
        );
}

export function notifyInfo(message, icon, button) {
    return dispatch =>
        dispatch(
            notify(
                notificationConstants.NOTIFICATION_LEVEL_INFO,
                message,
                icon,
                button
            )
        );
}

export function notifySuccess(message, icon, button) {
    return dispatch =>
        dispatch(
            notify(
                notificationConstants.NOTIFICATION_LEVEL_SUCCESS,
                message,
                icon,
                button
            )
        );
}



// WEBPACK FOOTER //
// ./src/modules/notifications/actions.js